export const useCmsSchemaOrg = (
	story: Record<string, any> | null | undefined
) => {
	const { buildCmsBreadcrumbItems } = useCmsBreadcrumb();

	const isArticle = story?.content?.component === "article";
	// The visible heading before the story name — editors name stories in
	// English ("Frequently Asked Questions & Answers") on Swedish sites.
	const pageHeading = story?.content?.Title || story?.name;
	const seoTitle =
		story?.content?.seo?.title ||
		story?.content?.SEO?.title ||
		pageHeading ||
		"";
	const seoDescription =
		story?.content?.seo?.description || story?.content?.SEO?.description || "";
	const ogImage =
		story?.content?.seo?.og_image || story?.content?.SEO?.og_image;
	const cmsBreadcrumbItems = buildCmsBreadcrumbItems(pageHeading);

	useSchemaOrg([
		defineWebPage({
			"@type": "WebPage",
			name: seoTitle,
			...(seoDescription ? { description: seoDescription } : {}),
			...(ogImage ? { image: ogImage } : {})
		}),
		...(isArticle
			? [
					defineArticle({
						headline: seoTitle,
						...(seoDescription || story?.content?.intro
							? { articleBody: seoDescription || story?.content?.intro }
							: {}),
						datePublished: story?.content?.date
							? new Date(story.content.date).toISOString()
							: new Date().toISOString()
					})
				]
			: []),
		...(cmsBreadcrumbItems.length > 0
			? [defineBreadcrumb({ itemListElement: cmsBreadcrumbItems })]
			: [])
	]);
};
